export default {
  path: '/auto-verificacoes',
  component: () => import('@/components/pages/AVServices/AVServices')
}
